import React, { useState, useEffect } from "react";
import { useNavigate , useLocation} from "react-router-dom";
import Swal from "sweetalert2";
import request from "../../../Apis/request";
import { BaseURL, uniqueToken } from "../../../api/DataApis";
import axios from "axios";
import { useParams } from "react-router-dom";

function Edit(props) {
  document.title = "Filter Category List | Edit";
  let navigate = useNavigate();
   let location = useLocation();
    let FilterCategoryEditData = location?.state?.FilterCategoryEditData;
    const sluggg = FilterCategoryEditData?.slug;
    console.log("FilterCategoryEditData", FilterCategoryEditData);
    let params = useParams();
    let CategoryID = params?.cid;

    console.log("categoryID", CategoryID);

    console.log("sluggg", sluggg);

  const [TitleName, setTitleName] = useState([]);
  const [selectedStatusType, setSelectedStatusType] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [Imageurl, setImageurl] = useState("");
  const [selectedPower, setSelectedPower] = useState([]);
  const [selectedVehicle, setSelectedVehicle] = useState([]);
  const [PowerListing, setPowerListing] = useState([]);
  const [Vehiclesnames, setVehiclesnames] = useState([]);
  const [showAdditionalInputs, setShowAdditionalInputs] = useState(false);
  const [selectedOcppConnector, setSelectedOcppConnector] = useState("0");
  const [CategoryEditData, setCategoryEditData] = useState({});


  const fetchData = async () => {
    const apiEndpoint = `${BaseURL}/master/edit/${CategoryID}`;
    
    try {
      let res = await axios.get(apiEndpoint, {
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
          Authorization: `Bearer ${uniqueToken}`,
          
        }
      });
  console.log("wholeeData", res);
      if (res  && res.data.data) {
        setCategoryEditData(res.data.data); // Set the first item in the data array
      } else {
        console.error("No charger data found");
      }
    } catch (error) {
      console.error("Error fetching charger data:", error);
    }
  }
  

  useEffect(() => {
    fetchData();
  }, []);
  // console.log("chargerData", charger);



  const handleAdditionalInput = (e) => {
    setSelectedOcppConnector(e.target.value.replace(/\D/, "")); // Ensure only integers are entered
  };

  const handlePowerInput=(e)=> {
    setSelectedPower([e.target.value]);
    };
    
    const handleVehicleInput=(e)=> {
      setSelectedVehicle(e.target.value);
      };

  useEffect(() => {
    // Fetch countries on component mount
    const fetchPowerListing = async () => {
      try {
        const response = await axios.get(`${BaseURL}/master/power-0`, {
          headers: {
            Authorization: `Bearer ${uniqueToken}`,
          },
        });
        setPowerListing(response.data.data);
      } catch (error) {
        console.error("Error fetching countries:", error);
      }
    };

    fetchPowerListing();
  }, []);

  useEffect(() => {
    // Fetch countries on component mount
    const fetchVehicleNamesListing = async () => {
      try {
        const response = await axios.get(`${BaseURL}/master/vehicles-name-0`, {
          headers: {
            Authorization: `Bearer ${uniqueToken}`,
          },
        });
        setVehiclesnames(response.data.data);
      } catch (error) {
        console.error("Error fetching countries:", error);
      }
    };

    fetchVehicleNamesListing();
  }, []);

  // New state for the additional input field
  const [additionalInput, setAdditionalInput] = useState("");

  // Show input if sluggg is 'dc-0' or 'ac-0'
  useEffect(() => {
    if (sluggg === "dc-0" || sluggg === "ac-0") {
      setShowAdditionalInputs(true);
    } else {
      setShowAdditionalInputs(false);
    }
  }, [sluggg]);

  useEffect(() => {
    // Ensure CategoryEditData is populated and master_select_power_id exists before running the logic
    if (CategoryEditData && CategoryEditData.master_select_power_id) {
      if (sluggg === "dc-0" || sluggg === "ac-0") {
        setSelectedPower(CategoryEditData.master_select_power_id[0]);
      } else {
        setShowAdditionalInputs(false);
      }
    }
  }, [CategoryEditData, sluggg]);

  useEffect(() => {
    // Ensure CategoryEditData is populated and master_select_power_id exists before running the logic
    if (CategoryEditData && CategoryEditData?.master_select_vehicle_type_id) {
      if (sluggg === "dc-0" || sluggg === "ac-0") {
        setSelectedVehicle(CategoryEditData?.master_select_vehicle_type_id[0]);
      } else {
        setShowAdditionalInputs(false);
      }
    }
  }, [CategoryEditData, sluggg]);
  



  useEffect(() => {
   
    setImageurl(FilterCategoryEditData?.master_image || null);
      
    },
   [FilterCategoryEditData]);
  

  const handleTitleName = (e) => {
    setTitleName(e.target.value);
  };
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setSelectedFile(file);
  }

  const handleStatusType = (e) => {
    setSelectedStatusType(e.target.value);
  };
  useEffect(() => {
    if (CategoryEditData) {
      setTitleName(CategoryEditData?.title || "");
      setSelectedStatusType(CategoryEditData.status || "");
      // setSelectedFile(FilterCategoryEditData?.master_image || null);
      
    }
  }, [CategoryEditData]);
  
  const UpdateFilterCategory = async (FilterCategoryEditData) => {
    // if (!FilterCategoryEditData || !FilterCategoryEditData._id) {
    //   console.error("Filter category ID is missing or FilterCategoryEditData is invalid");
    //   Swal.fire({
    //     icon: "error",
    //     title: "Error",
    //     text: "Filter category ID is missing.",
    //   });
    //   return;
    // }
  
    console.log("Updating Filter Category with ID:", FilterCategoryEditData._id);
  
    // Create a new FormData object
    let formData = new FormData();
  
    // Append the form data fields
    formData.append("title", TitleName);
    // formData.append("status", selectedStatusType);
    if( selectedFile ) {
      formData.append("master_image", selectedFile);
    }
    if (showAdditionalInputs) {
      formData.append("connectorId", selectedOcppConnector);
      }
      if (selectedPower) {
        formData.append("master_select_power_id", selectedPower);
        }
        if (selectedVehicle) {
          formData.append("master_select_vehicle_type_id", [selectedVehicle]);
          }
  
    Swal.fire({
      title: 'Updating Category...',
      text: 'Please wait',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
    // Make the API request
    let response = await request({
      url: `${BaseURL}/master/${FilterCategoryEditData._id}`,
      method: "PUT",
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${uniqueToken}`,
      }
    });
  
    // Handle the response
    if (response.statusCode === 200) {
      Swal.fire({
        icon: "success",
        title: "Success!",
        text: "Filter Category Updated Successfully...",
        showConfirmButton: false,
        timer: 1500,
      });
      navigate(`/masters/filtercategorylist`);
    } else {
      // Handle errors
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to update Filter Category",
      });
    }
  };
  
console.log("CategoryEditData", CategoryEditData);
  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12">
            <div className="card">
              <h1 className="page-title"></h1>
              <div className="portlet light bordered">
                <div className="portlet-title row">
                  <div className="caption font-dark col-md-10">
                    <h4 className="caption-subject bold uppercase mx-3">
                      Filter Category Edit
                    </h4>
                  </div>
                  <div className="caption font-dark col-md-2">
                    <h5 className="caption-subject bold uppercase mx-3">
                      <button className="btn btn-success" onClick={() => navigate(-1)}>
                        Back
                      </button>
                    </h5>
                  </div>
                </div>
                <div className="portlet-body mx-3">
                  <hr style={{ marginTop: "" }} />
                  <div className="row">
                    <div className="col-sm-12">
                      <form
                        className="form-horizontal"
                        encType="multipart/form-data"
                        role="form"
                        method="post"
                        style={{ marginTop: "-20px" }}
                      >
                        <div className="form-group">
                          <div className="row">
                            <label
                              htmlFor="name_id"
                              className="col-sm-2 control-label"
                            >
                              Title
                            </label>
                            <div className="col-sm-6">
                              <input
                              value={TitleName}
                                onChange={handleTitleName}
                                className="form-control"
                                id="name_id"
                                name="name"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        {showAdditionalInputs && (
                          <>
                          <div className="form-group">
                            <div className="row">
                              <label
                                htmlFor="additional_input"
                                className="col-sm-2 control-label"
                              >
                                Connector ID
                              </label>
                              <div className="col-sm-6">
                                <input
                                  type="number"
                            
                                  onChange={handleAdditionalInput}
                                  className="form-control"
                                  id="additional_input"
                                  placeholder="Enter an integer"
                                />
                              </div>
                              <span className="col-sm-4 control-label"></span>
                            </div>
                          </div>

<div className="form-group">
<div className="row">
  <label
    htmlFor="additional_input"
    className="col-sm-2 control-label"
  >
    Power
  </label>
  <div className="col-sm-6">
    <select
    value={selectedPower}

      onChange={handlePowerInput}
      className="form-control"
      id="additional_input"
      placeholder="Enter an integer"
    >
      <option value="">Select Power</option>
      {PowerListing?.map((item) => {
                                  return (
                                    <option
                                      key={item?._id}
                                      value={item?._id}
                                    >
                                      {item?.title}
                                    </option>
                                  );
                                })}
      </select>
  </div>
  <span className="col-sm-4 control-label"></span>
</div>
</div>
<div className="form-group">
<div className="row">
  <label
    htmlFor="additional_input"
    className="col-sm-2 control-label"
  >
    Vehicle
  </label>
  <div className="col-sm-6">
    <select
      

      onChange={handleVehicleInput}
      value={selectedVehicle}
      className="form-control"
      id="additional_input"
      placeholder="Enter an integer"
    >
      <option value="">Select Vehicle</option>
      {Vehiclesnames?.map((item) => {
                                  return (
                                    <option
                                      key={item?._id}
                                      value={item?._id}
                                    >
                                      {item?.title}
                                    </option>
                                  );
                                })}
      </select>
  </div>
  <span className="col-sm-4 control-label"></span>
</div>
</div>
</>
                          
                        )}

                        <div className="form-group">
                          <div className="row">
                            <label
                              htmlFor="name_id"
                              className="col-sm-2 control-label"
                            >
                              Image
                            </label>
                            <div className="col-sm-6">
                              <input
                              type="file"
                                onChange={handleFileChange}
                          
                                className="form-control"
                                id="file"
                                name="file"
                              />
                            </div>
                            <div className="col-sm-4 control-label">
            {/* Show image preview if an existing image URL is available */}
            {Imageurl && typeof Imageurl === 'string' && (
              <img
                src={Imageurl} // Use the image URL for src
                alt="Current Category"
                style={{ width: '100px', height: '100px', objectFit: 'cover', marginLeft: "180px" }}
              />
            )}

          
          </div>
                          </div>
                        </div>


                        {/* <div className="form-group">
                          <div className="row">
                            <label
                              htmlFor="statusType"
                              className="col-sm-2 control-label"
                            >
                              Status
                            </label>
                            <div className="col-sm-6">
                              <select
                                onChange={handleStatusType}
                                value={selectedStatusType}
                                type="text"
                                className="form-control"
                                id="statusType"
                                name="statusType"
                              >
                                <option value="0">Select Status</option>
                                <option value="Active">Active</option>
                                <option value="Inactive">Inactive</option>
                              </select>
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div> */}
                        <div className="form-group">
                          <div className="col-sm-offset-2 col-sm-8 add-class">
                            <input
                              type="button"
                              className="btn btn-success"
                              onClick={() => UpdateFilterCategory(FilterCategoryEditData)}
                              //ssssonClick={UpdateFilterCategory(FilterCategoryEditData)}
                              value="Update Category"
                            />
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Edit;
